import Vue from 'vue';
import VueRouter from 'vue-router';
import Workspaces from "./views/Workspaces.vue";
import CreateWorkspace from "./views/WorkspaceCreate.vue";
import WorkspaceDetail from "./views/WorkspaceDetail.vue";
import NotFound from "./views/NotFound.vue";
import Documentation from "./views/Documentation/Documentation.vue";
import UpdateWorkspace from "./views/WorkspaceUpdate.vue";

Vue.use(VueRouter)

export default new VueRouter({
    mode: "history", //Needed for adal
    routes: [
        {
            path: "",
            name: "home",
            component: Workspaces,
        },
        {
            path: "/Documentation",
            name: "Documentation",
            component: Documentation
        },
        {
            path: "/CreateWorkspace",
            name: "CreateWorkspace",
            component: CreateWorkspace
        },
        {
            path: "/UpdateWorkspace/:workspaceId",
            name: "UpdateWorkspace",
            component: UpdateWorkspace
        },
        {
            path: "/WorkspaceDetail/:resourceGroupName/:subscriptionId",
            name: "WorkspaceDetail",
            component: WorkspaceDetail
        },
        { 
            path: '*', 
            component: NotFound
        }
    ]
});

